import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripFootnote'
})
export class StripFootnotePipe implements PipeTransform {

    transform(value: string): string {
        if (!value) {
            return value;
        }
        return value.replace(/<xref[^>]*ref-type=["']fn["'][^>]*>[\s\S]*?<\/xref>/gi, '');
    }
}
